import React from 'react'
import { connect } from 'react-redux'
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import Loading from './widgets/Loading'
import Header from './widgets/Header'
import CrumbBox from './widgets/CrumbBox'
import CategoryList from './widgets/CategoryList'
import {
  CATEGORY_LIST_PAGE_LOADED,
  CATEGORY_LIST_PAGE_UNLOADED,
} from '../constants/actionTypes'
import { BASE_COIN_SYMBOL } from '../constants/config'

const mapStateToProps = state => ({
  ...state.settings,
  currentUser: state.common.currentUser,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: CATEGORY_LIST_PAGE_LOADED, payload })
  },
  onUnload: () =>
    dispatch({ type: CATEGORY_LIST_PAGE_UNLOADED }),
})

class CategoryManage extends React.Component {
  constructor() {
    super();
  }
  componentWillMount() {
    if (this.props.currentUser) {
      const payload = agent.Categories.getCategories(this.props.currentUser.key)
      this.props.onLoad(payload);
    }
  }

  componentWillUnmount() {
    this.props.onUnload();
  }
  render() {
    if (!this.props.categories) {
      return (
        <Loading />
      )
    }
    return (
      <div>
        <Header selected={'settings'} />
        <CrumbBox data={[{ key: 'Manage Categories' }]} rootKey='/settings' rootVal='Settings' />
        <div id="main"><div id="main-wrap">
          <div id="content">
            <h2>Manage Categories</h2>
            <CategoryList data={this.props.categories} mode={'edit'} />
          </div>
        </div></div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryManage)
